import { useEffect, useState } from 'react';
import { Api } from '../../services/api';
import { Modal } from '../../Components/Modal';
import { TokenModal } from '../../Components/TokenModal';
import { OffCanvas } from '../../Components/OffCanvas';
import { TokenCanvas } from '../../Components/TokenCanvas';

export const Token = () => {
  const [tokens, setTokens] = useState(null);

  const [isModalOpen, setModalOpen] = useState(false);
  //eslint-disable-next-line
  const [canvasOptions, setCanvasOption] = useState(true);

  const findAllTokens = async () => {
    try {
      const tokens = await Api.get('/token');
      console.log(tokens);
      setTokens(tokens.data);
    } catch (e) {
      setTokens(null);
    }
  };

  useEffect(() => {
    if (!isModalOpen) findAllTokens();
  }, [isModalOpen]);

  return (
    <div className="mt-4 container">
      <div className="mt-4"></div>
      <div className="row">
        <div className="col-3">
          <button
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#create-token-modal"
            onClick={() => setModalOpen(true)}
          >
            Criar token
          </button>
        </div>
        <div className="col-3"></div>
        <div className="col-3"></div>
        <div className="col-3"></div>
      </div>

      <table className="table mt-4">
        <thead>
          <tr>
            <th scope="col">Chave</th>
            <th scope="col">Motorista</th>
            <th scope="col">Transportadora</th>
            <th scope="col">Descrição</th>
            <th scope="col">-</th>
          </tr>
        </thead>
        <tbody>
          {tokens ? (
            tokens.map((token) => (
              <tr key={token.id}>
                <th scope="row">{token.id}</th>
                <td>{token.motorista}</td>
                <td>{token.transportadora}</td>
                <td>{token.descricao}</td>
                <td>
                  <button
                    className="btn btn-success"
                    data-bs-toggle="offcanvas"
                    data-bs-target={'#offcanvas-token'}
                    aria-controls="staticBackdrop"
                    onClick={() =>
                      setCanvasOption({
                        id: token.id,
                      })
                    }
                  >
                    Ver
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <td>Não foi encontrado nenhum token</td>
          )}
        </tbody>
      </table>

      <OffCanvas
        data={{
          key: 'token',
          title: 'Informações Token #' + canvasOptions.id,
        }}
      >
        <TokenCanvas options={canvasOptions} />
      </OffCanvas>

      <Modal data={{ ref: 'create-token-modal', title: 'Criar Token de acesso', isModalOpen: setModalOpen }}>
        {isModalOpen && <TokenModal />}
      </Modal>
    </div>
  );
};
